"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PromiseLimiter = (function () {
    function PromiseLimiter(n) {
        this.n = n;
    }
    PromiseLimiter.prototype.run = function (asyncFunc) {
        var _this = this;
        if (this.n === 0) {
            return new Promise(function (resolve) {
                _this.release = function () {
                    _this.n--;
                    var promise = asyncFunc();
                    promise.then(function () { return _this.doRelease(); }, function () { return _this.doRelease(); });
                    resolve({ promise: promise });
                };
            });
        }
        else {
            this.n--;
            var promise = asyncFunc();
            promise.then(function () { return _this.doRelease(); }, function () { return _this.doRelease(); });
            return Promise.resolve({ promise: promise });
        }
    };
    PromiseLimiter.prototype.doRelease = function () {
        this.n++;
        if (this.release !== undefined) {
            this.release();
            delete this.release;
        }
    };
    return PromiseLimiter;
}());
exports.PromiseLimiter = PromiseLimiter;
//# sourceMappingURL=index.js.map